import "./IconTrendArrow.scss";

export type TrendArrowDirection = "up" | "down";
export type TrendArrowColor = "green" | "red";

type Props = {
  direction: TrendArrowDirection;
  color?: TrendArrowColor;
};

export const IconTrendArrow = ({ direction, color = "green" }: Props) => {
  const rotationClass = direction === "down" ? "icon-trend-arrow--down" : "";
  const colorClass = color === "red" ? "icon-trend-arrow--red" : "icon-trend-arrow--green";

  return (
    <svg
      className={`icon-trend-arrow ${colorClass} ${rotationClass}`}
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5.96094 0.355469L10.3359 4.73047C10.6914 5.05859 10.6914 5.63281 10.3359 5.96094C10.0078 6.31641 9.43359 6.31641 9.10547 5.96094L6.23438 3.08984V11.457C6.23438 11.9492 5.82422 12.332 5.35938 12.332C4.86719 12.332 4.48438 11.9492 4.48438 11.457V3.08984L1.58594 5.96094C1.25781 6.31641 0.683594 6.31641 0.355469 5.96094C0 5.63281 0 5.05859 0.355469 4.73047L4.73047 0.355469C5.05859 0 5.63281 0 5.96094 0.355469Z"
        fill="currentColor"
      />
    </svg>
  );
};
